import { apiCall } from "./Interceptor";

const CREATE_BANKING = "/banking/create";
const GET_ALL_BANKING = "/banking/getAll?current=true";
const GET_MATCHING_LISTINGS = "/banking/matchmaking";
const UPDATE_BANKING_LISTING = "/banking/update";
const PLACE_REQUEST = "/banking/place";
const RECEIVED_REQUESTS = "/banking/received";
const UPDATE_BANKING_CONNECTION_STATUS = "/banking/updateStatusConnection";
const UPDATE_BANKING_LISTING_STATUS = "/banking/updateStatus";
const VIEW_SENT_BANKING_CONNECTION = "/banking/view-connection";
const GET_BANKING_LEDGER = "/banking/ledger";
const CREATE_LEDGER = "/banking/ledger/create";
const GET_BANKING_LIST = "banking/getOthers?current=true"
const UPDATE_DOCUMENT = "banking/updateDocuments"
const GENERATE_DOCS = "banking/generateLoaDocument"
const GENERATE_IND = "banking/getIntent"
const GENERATE_DOCS_PDF = "banking/generateListingDocument"

const createBanking = async (data) => {
  const response = await apiCall.post(CREATE_BANKING, data);
  return response;
};
const getAllMyBankingListing = async (data) => {
  const response = await apiCall.post(GET_ALL_BANKING, data);
  return response;
};
const getMatchingBankingListings = async (id, data) => {
  const response = await apiCall.post(
    `${GET_MATCHING_LISTINGS}?id=${id}`,
    data
  );
  return response;
};
const updateBankingListing = async (data) => {
  const response = await apiCall.put(UPDATE_BANKING_LISTING, data);
  return response;
};
const placeBankingConnectionRequest = async (data) => {
  const response = await apiCall.post(PLACE_REQUEST, data);
  return response;
};
const getReceivedBankingRequests = async (id) => {
  const response = await apiCall.get(`${RECEIVED_REQUESTS}?id=${id}`);
  return response;
};
const updateBankingConnectionStatus = async (data) => {
  const response = await apiCall.patch(UPDATE_BANKING_CONNECTION_STATUS, data);
  return response;
};
const updateBankingListingStatus = async (data) => {
  const response = await apiCall.patch(UPDATE_BANKING_LISTING_STATUS, data);
  return response;
};
const viewSentBankingConnection = async (connectionId, connectionAgainstId) => {
  const response = await apiCall.get(
    `${VIEW_SENT_BANKING_CONNECTION}?connectionId=${connectionId}&connectionAgainstId=${connectionAgainstId}`
  );
  return response;
};
const getBankingLedger = async () => {
  const response = await apiCall.get(GET_BANKING_LEDGER);
  return response;
};
const createLedger = async (data) => {
  const response = await apiCall.post(CREATE_LEDGER, data);
  return response;
};

const getAllBankingList = async (data) => {
 const response = await apiCall.post(GET_BANKING_LIST, data);
 return response;
};

const updateDocument = async (data) => {
 const response = await apiCall.patch(UPDATE_DOCUMENT, data);
 return response;
};

const getLoaDocument = async (id,type) => {
 const response = await apiCall.get(`${GENERATE_DOCS}?id=${id}&choice=${type}`);
 return response;
};

const getIntentById = async (id) =>{
    const response = await apiCall.get(`${GENERATE_IND}?id=${id}`);
    return response;
}   

const generateBankingDocs = async (id) => {
  const response = await apiCall.get(`${GENERATE_DOCS_PDF}?id=${id}`);
  return response;
};

export default {
 createBanking,
 getAllMyBankingListing,
 getMatchingBankingListings,
 updateBankingListing,
 placeBankingConnectionRequest,
 getReceivedBankingRequests,
 updateBankingConnectionStatus,
 updateBankingListingStatus,
 viewSentBankingConnection,
 getBankingLedger,
 createLedger,
 getAllBankingList,
 updateDocument,
 getLoaDocument,
 getIntentById,
 generateBankingDocs
};
